import { FormFooter, FormFooterCancel } from 'components';
import { useFormPrompt } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { Submit, useFormContext } from '../../forms/adminForm';

export interface AdminFormFooterProps {
  submitLoading?: boolean;
}

export const AdminFormFooter = ({ submitLoading }: AdminFormFooterProps) => {
  const { readOnly, setReadOnly, dirty, submitDisabled } = useFormContext();

  const { t } = useTranslation();

  const { confirmIsChanged } = useFormPrompt();

  const editable = !readOnly;

  const disableEditable = () => {
    confirmIsChanged(() => setReadOnly(true));
  };

  return (
    <FormFooter visible={editable}>
      <FormFooterCancel onClick={disableEditable} />
      <Submit
        disabled={submitDisabled || !dirty}
        label={t('common.save')}
        loading={submitLoading}
        sizeVariant="m"
      />
    </FormFooter>
  );
};
